import { useQuery } from '@tanstack/react-query';
import { rpcClient } from 'src/api/rpc/client';
// AR Technical Demo (F2 / GEN-2258) — demo-mode shim. Delete with frontend/src/demo/ar.
import {
  arDemoActive,
  useArDemoFixture,
  withArDemoData,
} from '@/demo/ar/hook-shim';

const QUERY_KEY_BASE = 'core-documents';

export function useListDocumentsForPicker(input?: {
  query?: string;
  limit?: number;
}) {
  return useQuery({
    queryKey: [QUERY_KEY_BASE, 'list-for-picker', input],
    queryFn: () => rpcClient.core.documents.listForPicker(input ?? {}),
  });
}

export function useDocumentPreview(documentId: string | null) {
  // AR Technical Demo: serve the Crestline evidence-doc previews from fixtures
  // so the thread document/remittance rows open in the real detail sheet.
  const demoData = useArDemoFixture((s) =>
    documentId ? s.documentPreviewsById[documentId] : undefined,
  );
  const query = useQuery({
    queryKey: [QUERY_KEY_BASE, 'preview', documentId],
    queryFn: () =>
      rpcClient.core.documents.getPreview({ documentId: documentId ?? '' }),
    enabled: !!documentId && !arDemoActive(),
  });
  return withArDemoData(query, demoData);
}

export function useDocumentOcrResultPreview(ocrResultId: string | null) {
  return useQuery({
    queryKey: [QUERY_KEY_BASE, 'ocr-preview', ocrResultId],
    queryFn: () =>
      rpcClient.core.documents.getOcrResultPreview({
        ocrResultId: ocrResultId ?? '',
      }),
    enabled: !!ocrResultId,
  });
}

export function useDocumentOcrResultContent(
  ocrResultId: string | null,
  enabled = true,
) {
  return useQuery({
    queryKey: [QUERY_KEY_BASE, 'ocr-content', ocrResultId],
    queryFn: () =>
      rpcClient.core.documents.getOcrResultContent({
        ocrResultId: ocrResultId ?? '',
      }),
    enabled: enabled && !!ocrResultId,
  });
}
